(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    function updateBannerImages() {
      var isMobile = window.innerWidth <= 767;
      document.querySelectorAll('.home-banner-items').forEach(function (el) {
        var mobileImg = el.getAttribute('data-mobile-image');
        var desktopImg = el.getAttribute('data-desktop-image');
        el.style.backgroundImage = isMobile && mobileImg ? `url(${mobileImg})` : `url(${desktopImg})`;
      });
    }

    updateBannerImages();
    window.addEventListener('resize', updateBannerImages);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", async function () {
  try {
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();
    const continent = data.continent_code;
    const country = data.country_name;

    console.log(country);
    console.log(continent);

    /*const caribbeanCountries = [
      "Bahamas", "Barbados", "Cuba", "Dominican Republic", "Haiti",
      "Jamaica", "Trinidad and Tobago", "Saint Lucia", "Grenada",
      "Antigua and Barbuda", "Saint Kitts and Nevis", "Saint Vincent and the Grenadines"
    ];*/

    const caribbeanCountries = ['United States'];

    if (!caribbeanCountries.includes(country)) {
      const bar = document.getElementById("location-bar");
      const text = document.getElementById("location-text");

      const messageTemplate = bar.getAttribute("data-template") || "";
      const redirectUrl = bar.getAttribute("data-url") || "#";
      const linkText = bar.getAttribute("data-link-text") || "Global store";
      const stayText = bar.getAttribute("data-stay-text") || "Stay here";

      const message = messageTemplate.replace("[country]", country);
      text.innerHTML = message.replace(linkText, `<a href="${redirectUrl}">${linkText}</a>`);

      document.getElementById("stay-here").textContent = stayText;

      bar.style.display = "block";

      document.getElementById("stay-here").addEventListener("click", function (e) {
        e.preventDefault();
        bar.style.display = "none";
      });
    }
  } catch (e) {
    console.error("Location detection failed:", e);
  }
});


  } catch(e) { console.error(e); }
})();
})();
